<template>
  <div class="EditSmartCurtainWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditSmartCurtainWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditSmartCurtainWidget-main lxn-pos-rel">
      <div class="EditSmartCurtainWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddTemperatureAutomationWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="EditSmartCurtainWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="EditSmartCurtainWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="EditSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="EditSmartCurtainWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="EditSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="EditSmartCurtainWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="EditSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="EditSmartCurtainWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="EditSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="EditSmartCurtainWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="EditSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="EditSmartCurtainWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddTemperatureAutomationWidget_namePlaceHolder" inputType="text" />
            </div>
            <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Folder_text}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetFolder" :dropDownContex="dropDownTargetFolder" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_title2}}
          </template>
          <template v-slot:body>
            <div class="EditSmartCurtainWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="curtainType" :dropDownContex="dropDownCurtainType" />
            </div>
            <div class="EditSmartCurtainWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_text3}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
          </template>
        </TitleBox>
        <TitleBox v-if="curtainType == 0" titleBgColor="#00AEEF" bgColor="#afd6e5">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_commands}}
          </template>
          <template v-slot:body>
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_up_description}}
            </div>
            <CommandCreator :key="1" v-model="generatedCommand_curtain_up" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_curtain_up_loaded" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_stop_description}}
            </div>
            <CommandCreator :key="2" v-model="generatedCommand_curtain_stop" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_curtain_stop_loaded" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_down_description}}
            </div>
            <CommandCreator :key="3" v-model="generatedCommand_curtain_down" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_curtain_down_loaded" />
          </template>
        </TitleBox>
        <TitleBox v-else titleBgColor="#00AEEF" bgColor="#afd6e5">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_commands}}
          </template>
          <template v-slot:body>
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_left_description}}
            </div>
            <CommandCreator :key="4" v-model="generatedCommand_curtain_left" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_curtain_left_loaded" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_stop_description}}
            </div>
            <CommandCreator :key="5" v-model="generatedCommand_curtain_stop" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_curtain_down_loaded" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_right_description}}
            </div>
            <CommandCreator :key="6" v-model="generatedCommand_curtain_right" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_curtain_right_loaded" />
          </template>
        </TitleBox>
      </div>
      <div class="EditSmartCurtainWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddTemperatureAutomationWidget_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'EditSmartCurtainWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    CommandCreator,
    DropDown
  },
  data: function () {
    return {
      widget: this.$store.state.widgets[this.$route.params.widgetIndex],
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      curtainType: 0,
      targetHub: 0,
      generatedCommand_curtain_up: [],
      generatedCommand_curtain_stop: [],
      generatedCommand_curtain_down: [],
      generatedCommand_curtain_left: [],
      generatedCommand_curtain_right: [],
      generatedCommand_curtain_up_loaded: [],
      generatedCommand_curtain_stop_loaded: [],
      generatedCommand_curtain_down_loaded: [],
      generatedCommand_curtain_left_loaded: [],
      generatedCommand_curtain_right_loaded: [],
      targetFolder: 0,
      folderList: [],
    }
  },
  mounted: function () {
    this.WidgetName = this.widget.name;
    this.activeBoxIndex = this.widget.color;
    this.targetHub = this.$store.getters.getHubByUUID(this.widget.hubUUID).index;
    this.curtainType = this.widget.settings.curtainType;

    this.generatedCommand_curtain_stop_loaded = this.generatedLoadableCommands(this.widget.settings.curtainStopCommand);
    if(this.curtainType == 0){
      this.generatedCommand_curtain_up_loaded = this.generatedLoadableCommands(this.widget.settings.curtainUpCommand);
      this.generatedCommand_curtain_down_loaded = this.generatedLoadableCommands(this.widget.settings.curtainDownCommand);
    }else{
      this.generatedCommand_curtain_left_loaded = this.generatedLoadableCommands(this.widget.settings.curtainLeftCommand);
      this.generatedCommand_curtain_right_loaded = this.generatedLoadableCommands(this.widget.settings.curtainRightCommand);
    }

    for(var i = 0; i < this.folderList.length; i++){
      if(this.folderList[i].path == this.widget.path){
        this.targetFolder = i;
      }
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownCurtainType: function () {
      return {
        name: "AddSmartCurtainWidget-curtainType",
        title: this.$store.getters.language.texts.AddSmartCurtainWidget_text2,
        selectedIndex: this.curtainType,
        data: [
          {
            name: this.$store.getters.language.texts.AddSmartCurtainWidget_curtainType1,
            icon: 'upDownCurtain',
          },
          {
            name: this.$store.getters.language.texts.AddSmartCurtainWidget_curtainType2,
            icon: 'leftRightCurtain',
          },
        ]
      }
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "EditSmartCurtainWidget-TargetHubs",
        title: this.$store.getters.language.texts.AddTemperatureAutomationWidget_text5,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetFolder: function () {
      this.folderListCleaner();
      var dropDownTargetFolder = {
        name: "AddSingleSwitchWidget-TargetOutputNoNc",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetFolder,
        data: [
          {
            name: this.$store.getters.language.texts.Root_text,
            icon: 'folder',
          },
        ]
      };
      this.folderListSetter(
        {
          widgetIndex: -1,
        }
      );
      for(var i = 0; i < this.$store.state.widgets.length; i++){
        if(this.$store.state.widgets[i].type == "folderWidget"){
          var folderWidget = this.$store.state.widgets[i];
          var parentPath = folderWidget.settings.parent;
          var parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          var folderName = folderWidget.name;
          while(parentFolder.length){
            folderName = parentFolder[0].name + " > " + folderName;
            parentPath = parentFolder[0].settings.parent;
            parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          }
          this.folderListSetter(
            {
              path: folderWidget.settings.path,
            }
          );
          dropDownTargetFolder.data.push({
            name: folderName,
            icon: "folder",
          })
        }
      }
      return dropDownTargetFolder;
    },
  },
  methods: {
    folderListSetter: function (obj) {
      this.folderList.push(obj);
    },
    folderListCleaner: function () {
      this.folderList = [];
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    generatedLoadableCommands: function (commandContex) {
      var loadedCommand = [];
      for(var i = 0; i < commandContex.length; i++){
        for(var j = 0; j < commandContex[i].actions.length; j++){
          var hub = this.$store.getters.getHubByUUID(commandContex[i].hubUUID);
          var node = this.$store.getters.getNodeByUUID(commandContex[i].actions[j].nodeUUID);
          var state = commandContex[i].actions[j].state;
          var delay = commandContex[i].actions[j].timeDelay;
          var output = null;
          var outputFound = false;
          if(commandContex[i].actions[j].outputType == "IrDevice"){
            for(var k = 0; k < node.outputs.length; k++){
              if(node.outputs[k].settings.brand == commandContex[i].actions[j].outputSettings.brand && node.outputs[k].settings.deviceType == commandContex[i].actions[j].outputSettings.deviceType && node.outputs[k].settings.model == commandContex[i].actions[j].outputSettings.model){
                output = node.outputs[k];
                outputFound = true;
                break;
              }
            }
          }else if(commandContex[i].actions[j].outputType == "RfDevice"){
            for(k = 0; k < node.outputs.length; k++){
              if(JSON.stringify(node.outputs[k].settings.deviceId) == JSON.stringify(commandContex[i].actions[j].outputSettings.deviceId) && node.outputs[k].settings.deviceType == commandContex[i].actions[j].outputSettings.deviceType){
                output = node.outputs[k];
                outputFound = true;
                break;
              }
            }

          }else{
            for(k = 0; k < node.outputs.length; k++){
              if(node.outputs[k].parameterId == commandContex[i].actions[j].parameterId){
                output = node.outputs[k];
                outputFound = true;
                break;
              }
            }
          }
          if(outputFound){
            loadedCommand.push({
              hub: hub,
              node: node,
              output: output,
              state: state,
              delay: delay
            });
          }
        }
      }
      return loadedCommand;
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddSingleSwitchWidget_alert1);
      }else if(this.curtainType == 0 && this.generatedCommand_curtain_up.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainUpNoCommand);
      }else if(this.curtainType == 0 && this.generatedCommand_curtain_down.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainDownNoCommand);
      }else if(this.curtainType == 1 && this.generatedCommand_curtain_left.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainLeftNoCommand);
      }else if(this.automationType == 1 && this.generatedCommand_curtain_right.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainRightNoCommand);
      }else if(this.generatedCommand_curtain_stop.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainStopNoCommand);
      }else{
        this.$store.commit('setAppBusy', true);
        var hubUUID = this.$store.state.hubs[this.targetHub].uuid;
        var path = this.folderList[this.targetFolder].path;
        var widget = {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "smartCurtainWidget",
          hubUUID: hubUUID,
          visible: true,
          path: path,
          settings: {
            curtainType: this.curtainType,
            curtainUpCommand: this.generatedCommand_curtain_up,
            curtainDownCommand: this.generatedCommand_curtain_down,
            curtainLeftCommand: this.generatedCommand_curtain_left,
            curtainRightCommand: this.generatedCommand_curtain_right,
            curtainStopCommand: this.generatedCommand_curtain_stop,
          }
        }
        this.$store.commit('editWidget', {
          widgetIndex: this.$route.params.widgetIndex,
          widget: widget,
        });
        this.$store.commit('saveState');
        this.$router.push('/home/dashboard/');
        this.$store.commit('setAppBusy', false);       
      }
    },
  }
}
</script>

<style>
  .EditSmartCurtainWidget-topCurve-wrapper {
    height: 200px;
  }
  .EditSmartCurtainWidget-main {
    z-index: 2;
  }
  .EditSmartCurtainWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .EditSmartCurtainWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .EditSmartCurtainWidget-wrapper-colors {
    height: 50px;
  }
  .EditSmartCurtainWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .EditSmartCurtainWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .EditSmartCurtainWidget-color.active .EditSmartCurtainWidget-selectedColor {
    opacity: 1;
  }
  .EditSmartCurtainWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .EditSmartCurtainWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .EditSmartCurtainWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .EditSmartCurtainWidget-wrapper-field-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .EditSmartCurtainWidget-description {
    margin-top: 14px;
    margin-bottom: 14px;
  }
 .EditSmartCurtainWidget-description:first-child {
    margin-top: 0;
  }
</style>
